import { render, staticRenderFns } from "./RelatedDeliverablesSocialMedia.vue?vue&type=template&id=117340f6&"
import script from "./RelatedDeliverablesSocialMedia.vue?vue&type=script&lang=js&"
export * from "./RelatedDeliverablesSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117340f6')) {
      api.createRecord('117340f6', component.options)
    } else {
      api.reload('117340f6', component.options)
    }
    module.hot.accept("./RelatedDeliverablesSocialMedia.vue?vue&type=template&id=117340f6&", function () {
      api.rerender('117340f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/RelatedDeliverablesSocialMedia.vue"
export default component.exports